import { z } from "zod";

import { PartAnalysisSchema, PartSchema } from "./PrismaZod";

export const ExtendedPartSchema = PartSchema.omit({
  heightOverride: true,
  widthOverride: true,
  lengthOverride: true,
  tubeThicknessOverride: true,
  weightOverride: true,
  quantityInAssemblyOverride: true,
}).merge(
  PartAnalysisSchema.pick({
    analyze2DStatus: true,
    analyzeStatus: true,
    area: true,
    boundingBoxArea: true,
    boundingBoxVolume: true,
    boundingBoxX: true,
    boundingBoxY: true,
    boundingBoxZ: true,
    drawingAnalyticExtractionStatus: true,
    drawingEmbeddingStatus: true,
    drawingLLMExtractionStatus: true,
    embeddingStatus: true,
    featuresStatus: true,
    gltfStatus: true,
    graphStatus: true,
    graphVersion: true,
    flatPatternStatus: true,
    height: true,
    length: true,
    materialGrade: true,
    materialName: true,
    pdfPreviewStatus: true,
    previewStatus: true,
    quantityInAssembly: true,
    surfaceTreatments: true,
    tolerance: true,
    topologicalEmbeddingStatus: true,
    tubeThickness: true,
    volume: true,
    weight: true,
    width: true,
    urlGltf: true,
    urlPdfAnnotated: true,
    urlPdfPreview: true,
  }).extend({
    urlPng2D: PartAnalysisSchema.shape.urlPng,
    urlPng3D: PartAnalysisSchema.shape.urlPng,
  }),
);

export type ExtendedPart = z.infer<typeof ExtendedPartSchema>;
